import React from 'react';
import {Link} from 'gatsby'

const SportsPassBreadcrumb = ({SingleTitle}) => (
	<div className="d-none d-lg-block d-md-block d-sm-block order-bottom py-2">
		<div className="container">
			<nav className="breadcrumb-navigation" aria-label="Fil d'Ariane">
				<ol className="breadcrumb" role="list">
					<li className="breadcrumb-item" role="listitem">
						<Link className="text-dark" to="/" aria-label="Retour à l'accueil">Accueil</Link>
					</li>
					<li className="breadcrumb-item" role="listitem">
						<Link className="text-dark" to="/services-infos-pratiques/" aria-label="Services et infos pratiques">Services & infos pratiques</Link>
					</li> 
					<li className="breadcrumb-item" role="listitem">
						<Link className="text-dark" to="/services-infos-pratiques/sports/" aria-label="Section Sports">Sports</Link>
					</li> 
					{ SingleTitle ?  
						<li className="text-secondary breadcrumb-item" role="listitem">
							<Link className="text-dark" to="/services-infos-pratiques/sports/annuaire-sport-pass/" aria-label="Annuaire Sport Pass">Annuaire Sport Pass</Link>
						</li> 
						: 
						<li className="text-secondary breadcrumb-item" role="listitem" aria-current="page">Annuaire Sport Pass</li> 
					}
					{ SingleTitle ? 
						<li className="text-secondary breadcrumb-item" role="listitem" aria-current="page">{SingleTitle}</li> 
						: '' 
					}
				</ol>
			</nav>
		</div>
	</div>
)

export default SportsPassBreadcrumb;